import { render, staticRenderFns } from "./delAndEdit.vue?vue&type=template&id=044a2b7a&scoped=true&"
import script from "./delAndEdit.vue?vue&type=script&lang=js&"
export * from "./delAndEdit.vue?vue&type=script&lang=js&"
import style0 from "./delAndEdit.vue?vue&type=style&index=0&id=044a2b7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044a2b7a",
  null
  
)

export default component.exports